export enum HttpStatusErrorCodes {
    INSUFFICIENT_QUANTITY = 409,
    CAMPAIGN_TRANSACTIONS_LIMIT_REACHED = 422,
    COUPON_LIMIT_REACHED = 423,
}
